import PropTypes from "prop-types"
import React from "react"
import Nav from "../Navigation/Nav"
import Styles from './header.module.scss'

const Header = () => {

  return (
    <header className={Styles.header}>
      <Nav />
    </header>
  )
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
